import Vue from 'vue';
import Vuex from 'vuex';

// Sa
import sa_sign_up from './modules/sa/sign-up';
import sa_qr_code from './modules/sa/qr-code';
import sa_profile from './modules/sa/profile';
import sa_contacts from './modules/sa/contacts';
import sa_label from './modules/sa/label';
import sa_reservation from './modules/sa/reservation';
import sa_my_customer from './modules/sa/my-customer';
import sa_msg_manager from './modules/sa/msg-manager';
import sa_chat from './modules/sa/chat';
import sa_temp from './modules/sa/temp';
import sa_group_push from './modules/sa/group_push';
import sa_invitation from './modules/sa/invitation';
import sa_member_search from './modules/sa/member-search';
import sa_event_activity from './modules/sa/event-activity';

// Member
import member_sign_up from './modules/member/sign-up';
import member_bind_sa from './modules/member/bind-sa';
import member_change_sa from './modules/member/change-sa';
import member_my_sa from './modules/member/my-sa';
import member_reservation from './modules/member/reservation';
import member_invitation from './modules/member/invitation';
import member_event_activity from './modules/member/event-activity';
import member_card from './modules/member/card';

// Sm
import sm_stores_manager from './modules/sm/stores-manager';
import sm_sign_up from './modules/sm/sign-up';
import sm_qr_code from './modules/sm/qr-code';
import sm_profile from './modules/sm/profile';
import sm_contacts from './modules/sm/contacts';
import sm_label from './modules/sm/label';
import sm_reservation from './modules/sm/reservation';
import sm_my_customer from './modules/sm/my-customer';
import sm_msg_manager from './modules/sm/msg-manager';
import sm_chat from './modules/sm/chat';
import sm_temp from './modules/sm/temp';
import sm_group_push from './modules/sm/group_push';
import sm_invitation from './modules/sm/invitation';
import sm_member_search from './modules/sm/member-search';
import sm_event_activity from './modules/sm/event-activity';

// Sic
import sic_stores_manager from './modules/sic/stores-manager';
import sic_profile from './modules/sic/profile';
import sic_event_activity from './modules/sic/event-activity';

import unbind_member_sign_up from './modules/unbindMember/sign-up';

Vue.use(Vuex);

const store = new Vuex.Store({
  // 嚴格模式，禁止直接修改 state，深度監測狀態樹來檢測不合規的狀態變更
  // 發布模式必須關閉避免性能損失
  strict: process.env.NODE_ENV !== 'production',
  state: {
    // 全域 Loading
    isLoading: true
  },
  mutations: {
    toggleLoading(state, Boolean) {
      state.isLoading = Boolean;
    }
  },
  modules: {
    // Sa
    sa_sign_up,
    sa_qr_code,
    sa_profile,
    sa_contacts,
    sa_label,
    sa_reservation,
    sa_my_customer,
    sa_msg_manager,
    sa_chat,
    sa_temp,
    sa_group_push,
    sa_invitation,
    sa_member_search,
    sa_event_activity,
    // Member
    member_sign_up,
    member_bind_sa,
    member_change_sa,
    member_my_sa,
    member_reservation,
    member_invitation,
    member_event_activity,
    member_card,
    // Sm
    sm_stores_manager,
    sm_sign_up,
    sm_qr_code,
    sm_profile,
    sm_contacts,
    sm_label,
    sm_reservation,
    sm_my_customer,
    sm_msg_manager,
    sm_chat,
    sm_temp,
    sm_group_push,
    sm_member_search,
    sm_invitation,
    sm_event_activity,
    // Sic
    sic_stores_manager,
    sic_profile,
    sic_event_activity,
    unbind_member_sign_up
  }
});

export default store;
